import base64 from '../global/base64.js';
import md5 from 'js-md5'
import store from '@/store/index.js';
import timeHelper from '../global/timeHelper.js';
import global from '../global/global.js'
import axios from 'axios';
import api from '../bykApi.js'

const fSmApiReq = async (sReqUrl, sApiName, sMethodName, sReqJsonStr, sApiUserPhone, sApiUserId, sApiReqFrom,
  sApiRandomStr, sApiReqOrgAk, sApiReqOrgSk, checkSignType = 'MD5') => {
  console.log(1234)
  let objByPayAdmin = global.fGetByPayAdmin()
  let sReqTime = timeHelper.fGetNowTime(2);
  // 请求参数BASE64
  let sReqJsonBase64 = Base64.encode(sReqJsonStr);

  // 组装签名

  let sApiReqSign = sApiReqOrgSk + sReqJsonBase64 + sReqTime + sApiReqOrgSk;
  sApiReqSign = md5(sApiReqSign);
  console.log(sApiReqSign)
  sApiReqSign = sApiReqSign.toLowerCase();

  let js = {};
  // API名称
  js['API_NAME'] = sApiName;
  // 请求方法名
  js['METHOD_NAME'] = sMethodName;
  // 请求json BASE64字符串
  js['REQ_JSON_STR'] = sReqJsonBase64;
  // API用户手机号
  js['API_USER_PHONE'] = sApiUserPhone;
  // API用户ID
  js['API_USER_ID'] = sApiUserId || '1001';
  // 请求来源
  js['API_REQ_FROM'] = sApiReqFrom;
  // 请求TOKEN
  js['API_REQ_TOKEN'] =   objByPayAdmin.orgUserInfo.token
  // 请求随机字符串
  js['API_RANDOM_STR'] = sApiRandomStr;
  // 请求机构AK
  js['API_REQ_ORG_AK'] = sApiReqOrgAk;
  // 请求签名
  js['API_REQ_SIGN'] = sApiReqSign;
  // 请求时间
  js['API_REQ_TIME'] = sReqTime;
  // console.log(js)
  // if (sApiName == 'smUnionPlatformAdminApi') {
  //   if (api.smCom.fSmIsEmpty(store.state.mSmUnionPlatformOrg.shLoadUrl)) {
  //     window.location.replace('http://soft.sanmipos.com/mSmUnionPlatformOrg/index.html')
  //     return {
  //       // data: {
  //       result: 'fail',
  //       msg: '请重新登录'
  //       // }
  //     }
  //   }
  //   if (sMethodName == 'USER_LOGIN') {
  //     //不需要token
  //   } else {
  //     if (api.smCom.fSmIsEmpty(sessionStorage.getItem('mSmUnionPlatformOrgToken'))) {
  //       window.location.replace('http://soft.sanmipos.com/mSmUnionPlatformOrg/index.html')
  //       return {
  //         // data: {
  //         result: 'fail',
  //         msg: '请重新登录'
  //         // }
  //       }
  //     }
  //   }
  //   //
  // }
  // startLoading()
  let res = await axios.post(sReqUrl, js);

  // endLoading()

  return res.data;
};


//smSell主服务器接口
const fPostToSmSellMainSrvApi = (sMethodName, reqJson = {}, post = '') => {
  // let sReqUrl = 'https://www.91byk.com/smSellMain/api/smSellApi/';
  let sReqUrl = 'https://www.91byk.com/smSellMain/api/smSellApi/';
  // let sApiUserPhone = "18957102098"
  // let sApiUserId = "1001"
  // if (post == 'QINIU' || post == 'OSS' || post == 'SMS' || post =='CLOULD') {
  let sApiUserPhone = store.state.mSmUnionPlatformOrg.shPhone || '18957102098'
  let sApiUserId = store.state.mSmUnionPlatformOrg.userId || '1001'
  // }
  return fSmApiReq(sReqUrl, 'smSellMainSrvApi', sMethodName, JSON.stringify(reqJson),
    sApiUserPhone, sApiUserId, 'H5端');
  // store.state.smWgoSh.phoneNo
};

//smBox接口
const fPostToSmBoxShopApi = async (sMethodName, reqJson = {}, post = '', apiName, postApi) => {
  let sReqUrl = 'http://8.142.76.240:5837' + "/api/smUnionPlatformApi/"
  let sApiName = 'smBoxShopApi'
  let sPostApi = 'smUnionPlatformApi'
  // console.log(sReqUrl)
  if (!api.smCom.fSmIsEmpty(post)) {
    if (!api.smCom.fSmIsEmpty(apiName)) {
      sApiName = apiName
    }
    if (!api.smCom.fSmIsEmpty(postApi)) {
      sPostApi = postApi
    }
    sReqUrl =  post + "/api/" + sPostApi + "/"
  }
  console.log(sReqUrl)
  return fSmApiReq(sReqUrl, sApiName, sMethodName, JSON.stringify(reqJson),
    '18957102098', '18957102098', 'smBoxShop', 'smBoxShop', reqJson.API_REQ_ORG_AK,
    reqJson.ORG_SK);
};

export default {
  fPostToSmSellMainSrvApi, //smSell主服务器接口
  fPostToSmBoxShopApi
}



// WEBPACK FOOTER //
// ./src/common/requset/smPayApi.js